import { IDestinationLinksOverviewPublicationFields } from '@models/publications/DestinationLinksOverview/types';
import { createContext, useContext } from 'react';

const destinationLinksContext = createContext<IDestinationLinksOverviewPublicationFields | null>(
  null,
);

export const DestinationLinksProvider = destinationLinksContext.Provider;
export const useDestinationLinks = () => useContext(destinationLinksContext);
